import { useState } from "react";
import JourneysSettings from "../components/settings-page/journeys-settings";
import HomepageMainContent from "../components/home-page/homepage-main-content";

const HomepageController = () => {
  const [showSettings, setShowSettings] = useState(false);

  return !showSettings ? (
    <HomepageMainContent setShowSettings={setShowSettings} />
  ) : (
    <JourneysSettings setShowSettings={setShowSettings} />
  );
};

export default HomepageController;
